import { QRCodeSVG } from 'qrcode.react';

const QR_URL = 'https://famagustagate.com';

interface QRPlaceholderProps {
  title: string;
}

export function QRPlaceholder({ title }: QRPlaceholderProps) {
  return (
    <QRCodeSVG
      value={QR_URL}
      title={title}
      size={108}
      bgColor="#ffffff"
      fgColor="#1F1812"
      level="M"
      className="w-full h-full"
    />
  );
}
